import { gql } from 'urql';
import { ModRewardTemplateDetails } from '../fragments/modRewardTemplate.graphql';
import { ModSignup } from '../fragments/modSignup.graphql';

export const createNewEvent = gql`
  mutation CreateNewEvent(
    $branchId: Int!
    $locationId: Int!
    $registrationOpensAt: String
    $startsAt: String!
    $endsAt: String!
    $name: String!
    $description: String
  ) {
    createEvent(
      input: {
        branchId: $branchId
        locationId: $locationId
        registrationOpensAt: $registrationOpensAt
        startsAt: $startsAt
        endsAt: $endsAt
        name: $name
        description: $description
        kind: live
      }
    ) {
      error
      event {
        id
        name
        description
        kind
        startsAt
        endsAt
        registrationOpensAt
        branch {
          id
        }
        location {
          id
        }
      }
    }
  }
`;

export const assignTemporaryManager = gql`
  mutation AssignTemporaryManager(
    $eventId: Int!
    $playerId: Int!
    $forRemoval: Boolean
  ) {
    assignTemporaryManager(
      input: { eventId: $eventId, playerId: $playerId, forRemoval: $forRemoval }
    ) {
      error
      event {
        id
        temporaryManagers {
          id
          user {
            id
            fullName
            userOrganization {
              id
              role
              branch {
                id
                shorthand
              }
            }
            ownedBranches {
              id
              shorthand
            }
          }
        }
      }
    }
  }
`;

export const updateEvent = gql`
  mutation UpdateEvent(
    $eventId: Int!
    $locationId: Int
    $registrationOpensAt: String
    $modSignupOpensAt: String
    $modMaxSignup: Int
    $modEnableWaitlist: Boolean
    $startsAt: String
    $endsAt: String
    $name: String
    $description: String
    $baseBuild: Int
    $maxExtraXp: Int
    $considersTravelersLocal: Boolean
    $kind: EventKindEnum
  ) {
    updateEvent(
      input: {
        eventId: $eventId
        locationId: $locationId
        registrationOpensAt: $registrationOpensAt
        startsAt: $startsAt
        endsAt: $endsAt
        name: $name
        description: $description
        baseBuild: $baseBuild
        maxExtraXp: $maxExtraXp
        considersTravelersLocal: $considersTravelersLocal
        kind: $kind
        modSignupOpensAt: $modSignupOpensAt
        modMaxSignup: $modMaxSignup
        modEnableWaitlist: $modEnableWaitlist
      }
    ) {
      error
      event {
        id
        kind
        name
        description
        startsAt
        endsAt
        registrationOpensAt
        modSignupOpensAt
        modMaxSignup
        modEnableWaitlist
        branch {
          id
        }
        location {
          id
        }
        config {
          baseBuild
          maxCurveXp
          extraXpCost
          maxExtraXp
          maxExtraXpLimit
          shiftUnit
          shiftMultiplier
          maxShift
          shiftKinds
          considersTravelersLocal
        }
      }
    }
  }
`;

export const copyEventSetup = gql`
  mutation CopyEventSetup(
    $sourceEventId: Int!
    $targetEventId: Int!
  ) {
    copyEventSetup(
      input: {
        sourceEventId: $sourceEventId
        targetEventId: $targetEventId
      }
    ) {
      error
      event {
        id
      }
    }
  }
`;

export const createModSection = gql`
  mutation CreateModSection(
    $eventId: Int!
    $name: String!
    $signupLimit: Int!
  ) {
    createModSection(
      input: {
        eventId: $eventId
        name: $name
        signupLimit: $signupLimit
      }
    ) {
      error
      event {
        id
        modSections {
          id
          name
          signupLimit
        }
      }
    }
  }
`;

export const updateModSection = gql`
  mutation UpdateModSection(
    $modSectionId: Int!
    $name: String
    $signupLimit: Int!
  ) {
    updateModSection(
      input: {
        modSectionId: $modSectionId
        name: $name
        signupLimit: $signupLimit
      }
    ) {
      error
      modSection {
        id
        name
        signupLimit
        mods {
          id
          name
          timeframe
          participationLimit
          description
          constraint
          modSignups {
            ...ModSignup
          }
        }
      }
    }
  }
  ${ModSignup}
`;

export const createMod = gql`
  mutation CreateMod(
    $modSectionId: Int!
    $name: String!
  ) {
    createMod(
      input: {
        modSectionId: $modSectionId
        name: $name
      }
    ) {
      error
      modSection {
        id
        name
        signupLimit
        mods {
          id
          name
          timeframe
          participationLimit
          description
          constraint
          modSignups {
            ...ModSignup
          }
        }
      }
    }
  }
  ${ModSignup}
`;

export const destroyMod = gql`
  mutation DestroyMod(
    $modId: Int!
  ) {
    destroyMod(
      input: {
        modId: $modId
      }
    ) {
      error
      modSection {
        id
        name
        signupLimit
        mods {
          id
          name
          timeframe
          participationLimit
          description
          constraint
          modSignups {
            ...ModSignup
          }
        }
      }
    }
  }
  ${ModSignup}
`;

export const updateMod = gql`
  mutation UpdateMod(
    $modId: Int!
    $name: String
    $participationLimit: Int
    $description: String
    $timeframe: String
    $modRunnerId: Int
    $currentAssetId: Int
    $activeModRewardTemplateId: Int
  ) {
    updateMod(
      input: {
        modId: $modId
        name: $name
        participationLimit: $participationLimit
        description: $description
        timeframe: $timeframe
        modRunnerId: $modRunnerId
        currentAssetId: $currentAssetId
        activeModRewardTemplateId: $activeModRewardTemplateId
      }
    ) {
      error
      mod {
        id
        name
        timeframe
        participationLimit
        description
        constraint
        modSignups {
          ...ModSignup
        }
        modRunner {
          id
          user {
            id
            fullName
          }
        }
        currentAsset {
          id
          name
          url
        }
        activeModRewardTemplate {
          ...ModRewardTemplateDetails
        }
      }
    }
  }
  ${ModSignup}
  ${ModRewardTemplateDetails}
`;

export const createModAsset = gql`
  mutation CreateModAsset(
    $modId: Int!
    $url: String!
  ) {
    createModAsset(
      input: {
        modId: $modId
        url: $url
      }
    ) {
      error
      mod {
        id
        modAssets {
          id
          name
          url
        }
      }
    }
  }
`;

export const updateModAsset = gql`
  mutation UpdateModAsset(
    $modId: Int!
    $modAssetId: Int!
    $name: String
  ) {
    updateModAsset(
      input: {
        modId: $modId
        modAssetId: $modAssetId
        name: $name
      }
    ) {
      error
      modAsset {
        id
        name
        url
      }
    }
  }
`;

export const destroyModAsset = gql`
  mutation DestroyModAsset(
    $modId: Int!
    $modAssetId: Int!
  ) {
    destroyModAsset(
      input: {
        modId: $modId
        modAssetId: $modAssetId
      }
    ) {
      error
      mod {
        id
        modAssets {
          id
          name
          url
        }
      }
    }
  }
`;

export const createModSignup = gql`
  mutation CreateModSignup(
    $modId: Int!
    $playerId: Int!
  ) {
    createModSignup(
      input: {
        modId: $modId
        playerId: $playerId
      }
    ) {
      error
      mod {
        id
        name
        timeframe
        participationLimit
        description
        constraint
        modSignups {
          ...ModSignup
        }
      }
    }
  }
  ${ModSignup}
`;

export const updateModSignup = gql`
  mutation UpdateModSignup(
    $modSignupId: Int!
    $characterId: Int!
  ) {
    updateModSignup(
      input: {
        modSignupId: $modSignupId
        characterId: $characterId
      }
    ) {
      error
      mod {
        id
        name
        timeframe
        participationLimit
        description
        constraint
        modSignups {
          ...ModSignup
        }
      }
    }
  }
  ${ModSignup}
`;

export const destroyModSignup = gql`
  mutation DestroyModSignup(
    $modSignupId: Int!
  ) {
    destroyModSignup(
      input: {
        modSignupId: $modSignupId
      }
    ) {
      error
      mod {
        id
        name
        timeframe
        participationLimit
        description
        constraint
        modSignups {
          ...ModSignup
        }
      }
    }
  }
  ${ModSignup}
`;

export const createEventTicket = gql`
  mutation CreateEventTicket(
    $eventId: Int!
    $label: String!
    $cost: Int!
    $limit: Int
    $shiftResponsibilities: Int!
    $restrictionType: TicketRestrictionEnum!
  ) {
    createEventTicket(
      input: {
        eventId: $eventId
        label: $label
        cost: $cost
        limit: $limit
        shiftResponsibilities: $shiftResponsibilities
        restrictionType: $restrictionType
      }
    ) {
      error
      event {
        id
        tickets(editMode: true) {
          id
          cost
          label
          limit
          discountType
          passType
          restrictionType
          shiftResponsibilities
          fixedLimit
          fullyBooked
          eventAttendeesCount
        }
      }
    }
  }
`;

export const createEventShfit = gql`
  mutation CreateEventShift(
    $eventId: Int!
    $label: String!
    $baseRatio: Int!
    $kind: ShiftKindEnum!
  ) {
    createEventShift(
      input: {
        eventId: $eventId
        label: $label
        baseRatio: $baseRatio
        kind: $kind
      }
    ) {
      error
      event {
        id
        shiftKinds
        shifts(withFulfillments: true) {
          id
          label
          baseRatio
          limit
          kind
          isEnabled
          autoExpand
          adjustableExpansionStrategy
          playersCount
          attendeeShifts {
            id
            status
            player {
              id
              fullName
              roleInOrganization
            }
          }
        }
      }
    }
  }
`;

export const destroyEventShift = gql`
  mutation DestroyEventShift($shiftId: Int!) {
    destroyEventShift(input: { shiftId: $shiftId }) {
      error
      event {
        id
        shiftKinds
        shifts(withFulfillments: true) {
          id
          label
          baseRatio
          limit
          kind
          isEnabled
          autoExpand
          adjustableExpansionStrategy
          playersCount
          attendeeShifts {
            id
            status
            player {
              id
              fullName
              roleInOrganization
            }
          }
        }
      }
    }
  }
`;

export const updateEventTicket = gql`
  mutation UpdateEventTicket(
    $ticketId: Int!
    $label: String
    $cost: Int
    $extraXpCost: Int
    $limit: Int
    $unlimited: Boolean
    $modMaxSignup: Int
    $econRestriction: TicketEconRestrictionEnum
  ) {
    updateEventTicket(
      input: {
        ticketId: $ticketId
        label: $label
        cost: $cost
        extraXpCost: $extraXpCost
        limit: $limit
        unlimited: $unlimited
        modMaxSignup: $modMaxSignup
        econRestriction: $econRestriction
      }
    ) {
      error
      ticket {
        id
        cost
        extraXpCost
        label
        limit
        eventAttendeesCount
        fullyBooked
        modMaxSignup
        econRestriction
      }
    }
  }
`;

export const updateEventShift = gql`
  mutation UpdateEventShift(
    $shiftId: Int!
    $label: String
    $limit: Int
    $baseRatio: Int
    $autoExpand: Boolean
    $isEnabled: Boolean
  ) {
    updateEventShift(
      input: {
        shiftId: $shiftId
        label: $label
        limit: $limit
        baseRatio: $baseRatio
        autoExpand: $autoExpand
        isEnabled: $isEnabled
      }
    ) {
      error
      shift {
        id
        label
        limit
        baseRatio
        autoExpand
        isEnabled
      }
    }
  }
`;

export const fulfillShift = gql`
  mutation FulfillShift($attendeeShiftId: Int!, $isFulfilled: Boolean!) {
    fulfillShift(
      input: { attendeeShiftId: $attendeeShiftId, isFulfilled: $isFulfilled }
    ) {
      error
      attendeeShift {
        id
        status
      }
    }
  }
`;

export const checkin = gql`
  mutation Checkin(
    $ticketId: Int!
    $playerId: Int!
    $shiftIds: [Int!]!
    $characters: [CheckinCharacterInput!]
    $printRequestOnCharacterIds: [Int!]!
    $buildGrowth: Int!
    $isAttending: Boolean
    $isPaid: Boolean
  ) {
    checkin(
      input: {
        ticketId: $ticketId
        playerId: $playerId
        shiftIds: $shiftIds
        characters: $characters
        printRequestOnCharacterIds: $printRequestOnCharacterIds
        buildGrowth: $buildGrowth
        isAttending: $isAttending
        isPaid: $isPaid
      }
    ) {
      error
    }
  }
`;

export const updateCheckin = gql`
  mutation updateCheckin(
    $eventAttendeeId: Int!
    $printRequestOnCharacterIds: [Int!]
    $characters: [CheckinCharacterInput!]
    $buildGrowth: Int
    $ticketId: Int
    $shiftIds: [Int!]
    $isAttending: Boolean
    $isPaid: Boolean
  ) {
    updateEventAttendee(
      input: {
        eventAttendeeId: $eventAttendeeId
        printRequestOnCharacterIds: $printRequestOnCharacterIds
        characters: $characters
        buildGrowth: $buildGrowth
        ticketId: $ticketId
        shiftIds: $shiftIds
        isAttending: $isAttending
        isPaid: $isPaid
      }
    ) {
      error
      eventAttendee {
        id
        buildAwarded
        buildGrowth
        checkinApproved
        kind
        paid
        attending
        shifts {
          id
          label
        }
        ticket {
          id
          cost
          identifier
          label
          passType
          shiftResponsibilities
        }
        attendeeCharacters {
          id
          printRequestStatus
          character {
            id
            name
            status
          }
        }
      }
    }
  }
`;

export const rejectCheckin = gql`
  mutation DestroyEventAttendee($eventAttendeeId: Int!) {
    destroyEventAttendee(input: { eventAttendeeId: $eventAttendeeId }) {
      error
      eventAttendee {
        id
        ticket {
          id
        }
      }
    }
  }
`;

export const updateEventAttendee = gql`
  mutation UpdateEventAttendee(
    $eventAttendeeId: Int!
    $printRequestOnCharacterIds: [Int!]
    $referralInfo: String
    $characters: [CheckinCharacterInput!]
    $buildGrowth: Int
    $ticketId: Int
    $inviterId: Int
    $shiftIds: [Int!]
    $isAttending: Boolean
    $isPaid: Boolean
    $costOverride: Int
  ) {
    updateEventAttendee(
      input: {
        eventAttendeeId: $eventAttendeeId
        printRequestOnCharacterIds: $printRequestOnCharacterIds
        referralInfo: $referralInfo
        characters: $characters
        buildGrowth: $buildGrowth
        ticketId: $ticketId
        inviterId: $inviterId
        shiftIds: $shiftIds
        isAttending: $isAttending
        isPaid: $isPaid
        costOverride: $costOverride
      }
    ) {
      error
      eventAttendee {
        id
        buildGrowth
        kind
        paid
        attending
        referralInfo
        costOverride
        user {
          id
          fullName
        }
        attendeeCharacters {
          id
          character {
            id
            name
          }
        }
        ticket {
          id
          label
        }
        shifts {
          id
        }
      }
    }
  }
`;

export const logBlueprintAction = gql`
  mutation LogBluePrintAction(
    $blueprintId: Int!
    $eventId: Int!
    $action: BlueprintActionEnum!
    $copies: Int!
    $fingerprints: [String!]!
  ) {
    logBlueprintAction(
      input: {
        blueprintId: $blueprintId
        eventId: $eventId
        action: $action
        copies: $copies
        fingerprints: $fingerprints
      }
    ) {
      success
      error
    }
  }
`;
